import React, { Component } from 'react'
import ActiveCategorypic from './ActiveCategorypic'
export default class MyModalBody extends Component {
    constructor(props){
        super(props)
        this.getCategoryID = this.getCategoryID.bind(this)
        this.isModalClose = this.isModalClose.bind(this)
    }
    getCategoryID(cid){
        this.props.callback(cid)
    }
    isModalClose(show){
        console.log(show)
    }
    render() {
        return (
            <>
                <ActiveCategorypic close={this.props.onclose} setFocus={this.props.setFocus} fun={this.getCategoryID} funForExitModal={this.isModalClose}/>
            </>
        )
    }
}
